import { useContent } from "@/context/ContentContext";

export default function About() {
  const { content } = useContent();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 md:py-28 bg-[#EAE0D5]/60 relative"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="overline">The story</p>
          <h2
            data-testid="about-title"
            className="font-serif-display text-4xl md:text-5xl mt-3 leading-[1.1] text-[#232E26]"
          >
            A private slice of the Aegean,<br />
            <em className="not-italic text-[#1A5A7B]">to call your own.</em>
          </h2>
          <div className="divider-line my-8 max-w-[120px]" />
          <p className="text-[#232E26]/85 leading-relaxed whitespace-pre-line text-[15px] md:text-base">
            {content.longAbout}
          </p>
        </div>

        <div className="md:col-span-7">
          <div className="grid sm:grid-cols-2 gap-px bg-[#5B6E4A]/15">
            {content.highlights.map((h, i) => (
              <div
                key={i}
                data-testid={`highlight-${i}`}
                className="bg-[#FAF7F2] p-8 md:p-10"
              >
                <p className="overline text-[#C65D47]">0{i + 1}</p>
                <h3 className="font-serif-display text-2xl mt-4 text-[#232E26]">
                  {h.title}
                </h3>
                <p className="mt-3 text-[#5B6E4A] leading-relaxed text-[15px]">
                  {h.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
